import Middleware from './middleware';
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime';

// Active schemes
import { RefreshScheme } from '~auth/runtime';
Middleware.auth = authMiddleware;
export default function (ctx, inject) {
  // Options
  var options = {
    "resetOnError": false,
    "ignoreExceptions": false,
    "scopeKey": "scope",
    "rewriteRedirects": true,
    "fullPathRedirect": false,
    "watchLoggedIn": true,
    "redirect": {
      "login": false,
      "logout": "/",
      "home": false,
      "callback": "/login"
    },
    "vuex": {
      "namespace": "auth"
    },
    "cookie": false,
    "localStorage": {
      "prefix": "auth."
    },
    "defaultStrategy": "local"
  };

  // Create a new Auth instance
  var $auth = new Auth(ctx, options);

  // Register strategies
  // local
  $auth.registerStrategy('local', new RefreshScheme($auth, {
    "token": {
      "property": "data.token"
    },
    "refreshToken": {
      "property": "data.refresh_token",
      "data": "refresh_token",
      "tokenRequired": true
    },
    "endpoints": {
      "login": {
        "url": "/v1/account/auth/login",
        "method": "post"
      },
      "refresh": {
        "url": "/v1/account/auth/refresh",
        "method": "post"
      },
      "user": false,
      "logout": false
    },
    "name": "local"
  }));

  // Inject it to nuxt context as $auth
  inject('auth', $auth);
  ctx.$auth = $auth;

  // Initialize auth
  return $auth.init().catch(function (error) {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return;
      }
      console.error('[ERROR] [AUTH]', error);
    }
  });
}